import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f46425"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "features" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Features", -1))
const _hoisted_3 = { class: "my-container" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feature" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "one-shot" }, "More accurate"),
  /*#__PURE__*/_createElementVNode("ul", { class: "detail" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Opt & Freq: "),
      /*#__PURE__*/_createElementVNode("i", null, "B3LYP-D3(BJ)/6-311G(d)/SMD/water")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("SPE: "),
      /*#__PURE__*/_createElementVNode("i", null, "B3LYP-D3(BJ)/def2TZVP/SMD/water")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, "53 global and 5 local QC properties")
  ])
], -1))
const _hoisted_6 = { class: "feature" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "one-shot" }, "Broader Chemical Compound Space", -1))
const _hoisted_8 = { class: "detail" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "9 element (C, H, O, N, P, S, F, Cl and Br) composition", -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"feature\" data-v-37f46425><p class=\"one-shot\" data-v-37f46425>High Quality Experimental Data</p><ul class=\"detail\" data-v-37f46425><li data-v-37f46425>23 dedicated endpoints</li><li data-v-37f46425>Strict preprocessing protocol</li><li data-v-37f46425>Distinguish conformation</li></ul></div><div class=\"feature\" data-v-37f46425><p class=\"one-shot\" data-v-37f46425>Visualization</p><ul class=\"detail\" data-v-37f46425><li data-v-37f46425>Intuitive</li><li data-v-37f46425>Interactive</li></ul></div>", 2)
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, _toDisplayString($setup.total.toLocaleString()) + " compounds with " + _toDisplayString($setup.scaffoldNum.toLocaleString()) + " scaffolds", 1),
            _hoisted_9,
            _createElementVNode("li", null, _toDisplayString(Math.ceil($setup.atomAvg).toLocaleString()) + " atoms and " + _toDisplayString(Math.ceil($setup.heavyAvg).toLocaleString()) + " heavy atoms per molecule, averagely", 1)
          ])
        ]),
        _hoisted_10
      ]),
      _hoisted_12
    ])
  ]))
}